<ng-form #taskForm="ngForm" class="task-creation-panel-container">
    <div class="task-creation-header">
        <gsp-button [type]="ButtonType.Icon" [iconClass]="'icon-arrow-back-black i24'" (action)="back()"></gsp-button>
        <h2 class="title">{{ headerText[taskCreationMode] }}</h2>
    </div>

    <loading *ngIf="loading" class="loading-align-center"></loading>

    <custom-scroll
        *ngIf="!loading"
        class="task-creation-body"
        [ngClass]="{ 'task-edit-mode': checkTaskMode(TaskCreationMode.EDIT) }"
    >
        <div class="error-notification" *ngIf="exceedsLimit">
            <gsp-notification [type]="NotificationType.Error" class="notification-icon">
                {{ 'TodosTasks.ExceedsLimit' | translate: { maxTaskFeatureCount: maxTaskFeatureCount } }}
            </gsp-notification>
        </div>

        <section>
            <span class="mandatory-asterisk">{{ 'TC.Common.Name' | translate }}</span>
            <input
                gsp-focus
                preventScroll="true"
                name="taskTitle"
                [(ngModel)]="task.title"
                class="gsp-form-input"
                [errorTooltip]="getErrorText(taskTitle)"
                required
                maxlength="1024"
                #taskTitle="ngModel"
            />
        </section>
        <section>
            <span>{{ 'TC.Common.Description' | translate }}</span>
            <gsp-text-area name="taskDescription" [(value)]="task.description" [maxLength]="1024"></gsp-text-area>
        </section>
        <section>
            <span [ngClass]="{ 'section-header': checkTaskMode(TaskCreationMode.EDIT) }">{{
                'TC.Common.AssignedUsers' | translate
            }}</span>
            <user-filter
                *ngIf="!checkTaskMode(TaskCreationMode.EDIT)"
                class="tag-input-alternative"
                [inputClass]="'tag-input-form'"
                [(selectedUsers)]="task.assignees"
                [allUsers]="currentProjectAssignees"
                [placeholder]="'TC.Common.SearchByTypingName' | translate"
            ></user-filter>
            <div *ngIf="checkTaskMode(TaskCreationMode.EDIT)" class="task-assigned-users-list">
                <task-assigned-users
                    [isTaskEditMode]="true"
                    [task]="task"
                    (selectedAssigneesChange)="onAssigneesChange($event)"
                ></task-assigned-users>
            </div>
        </section>
        <section *ngIf="checkTaskMode(TaskCreationMode.EDIT) && task.totalFeatures">
            <span class="section-header">{{ 'TC.Common.Forms' | translate }}</span>
            <div class="task-form-selection-list">
                <task-forms-selection
                    [taskCreationMode]="TaskCreationMode.EDIT"
                    [task]="task"
                    (layerToFeaturesMap)="setLayerToFeaturesMap($event)"
                ></task-forms-selection>
            </div>
        </section>
        <section *ngIf="!checkTaskMode(TaskCreationMode.EDIT)" class="required-form-selection">
            <div class="form-selection-summary">
                <task-forms-selection
                    [task]="task"
                    [taskCreationMode]="taskCreationMode"
                    (layerToFeaturesMap)="setLayerToFeaturesMap($event)"
                    (addVisibleFormsToSelection)="addVisibleFormsToSelection()"
                ></task-forms-selection>
            </div>
        </section>
    </custom-scroll>
</ng-form>

<footer>
    <gsp-button
        [disabled]="!taskForm.valid || exceedsLimit"
        [type]="ButtonType.Primary"
        [asyncAction]="saveAction"
        [text]="
            checkTaskMode(TaskCreationMode.EDIT) ? ('TC.Common.Done' | translate) : ('ToDos.CreateTask' | translate)
        "
        id="create-task"
    ></gsp-button>
    <gsp-button
        [disabled]="loading"
        [type]="ButtonType.Transparent"
        (action)="cancelSave()"
        text="{{ 'cancel' | translate }}"
        id="cancel-create-task"
    ></gsp-button>
</footer>
